"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationClient = void 0;
var HTTPClient_1 = require("../HTTPClient");
var AuthenticationClientConfig_1 = require("./AuthenticationClientConfig");
var AuthenticationClientRedirecter_1 = require("./AuthenticationClientRedirecter");
var PKCEChallengeProvider_1 = require("./PKCEChallengeProvider");
var AuthenticationClient = /** @class */ (function () {
    function AuthenticationClient(redirecter, config, pkceChallengeProvider) {
        var _this = this;
        this.redirecter = redirecter;
        this.config = config;
        this.pkceChallengeProvider = pkceChallengeProvider;
        this.loginWithCodeFlow = function (_a) {
            var redirect_uri = _a.redirect_uri, _b = _a.response_type, response_type = _b === void 0 ? 'code' : _b, connection = _a.connection, _c = _a.emulateAuthenticatedUser, emulateAuthenticatedUser = _c === void 0 ? false : _c, _d = _a.forceInteractiveLogin, forceInteractiveLogin = _d === void 0 ? false : _d, _e = _a.createUser, createUser = _e === void 0 ? false : _e, _f = _a.isTestUser, isTestUser = _f === void 0 ? false : _f;
            return __awaiter(_this, void 0, void 0, function () {
                var code_challenge, params, apiUrlForAuthFlow;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            code_challenge = this.pkceChallengeProvider.createChallenge().code_challenge;
                            params = new URLSearchParams();
                            params.set('redirect_uri', redirect_uri);
                            params.set('response_type', response_type);
                            params.set('code_challenge', code_challenge);
                            if (connection) {
                                params.set('connection', connection);
                            }
                            if (emulateAuthenticatedUser) {
                                params.set('emulateAuthenticatedUser', 'true');
                            }
                            if (isTestUser) {
                                params.set('isTestUser', 'true');
                            }
                            if (forceInteractiveLogin) {
                                params.set('forceInteractiveLogin', 'true');
                            }
                            if (createUser) {
                                params.set('createUser', 'true');
                            }
                            apiUrlForAuthFlow = "".concat(this.config.baseURL, "/oauth/authorize?").concat(params.toString());
                            return [4 /*yield*/, this.redirecter.redirect(apiUrlForAuthFlow)];
                        case 1: return [2 /*return*/, _g.sent()];
                    }
                });
            });
        };
        this.exchangeCode = function (_a) {
            var code = _a.code, currentUserAccessToken = _a.currentUserAccessToken;
            return __awaiter(_this, void 0, void 0, function () {
                var code_verifier, headers, body, res;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            code_verifier = this.pkceChallengeProvider.getLastVerifier().code_verifier;
                            if (!code_verifier) {
                                throw new Error('code_verifier is required to exchange code using PKCE flow');
                            }
                            headers = {};
                            if (currentUserAccessToken) {
                                headers.authorization = "JWT ".concat(currentUserAccessToken);
                            }
                            body = {
                                grant_type: 'code',
                                code: code,
                                code_verifier: code_verifier
                            };
                            return [4 /*yield*/, new HTTPClient_1.HTTPClient({ baseURL: this.config.baseURL }).post("/oauth/token", body, headers)];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res.data];
                    }
                });
            });
        };
        this.getGuestAccessToken = function (_a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.isTestUser, isTestUser = _c === void 0 ? false : _c;
            return __awaiter(_this, void 0, void 0, function () {
                var headers, body, res;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            headers = {};
                            body = {
                                // client_credentials is the "flow"
                                // we're not sending any credentials b/c this "No authentication (public client)"
                                grant_type: 'client_credentials',
                                createUser: true,
                                isTestUser: isTestUser
                            };
                            return [4 /*yield*/, new HTTPClient_1.HTTPClient({ baseURL: this.config.baseURL }).post("/oauth/token", body, headers)];
                        case 1:
                            res = _d.sent();
                            return [2 /*return*/, res.data];
                    }
                });
            });
        };
        this.refreshAccessToken = function (_a) {
            var refresh_token = _a.refresh_token;
            return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, new HTTPClient_1.HTTPClient({ baseURL: this.config.baseURL }).post("/oauth/token", {
                                grant_type: 'refresh',
                                refresh_token: refresh_token
                            })];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res.data];
                    }
                });
            });
        };
        this.revokeRefreshToken = function (_a) {
            var refresh_token = _a.refresh_token;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, new HTTPClient_1.HTTPClient({ baseURL: this.config.baseURL }).post("/oauth/revoke", { refresh_token: refresh_token })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.logout = function (_a) {
            var redirect_uri = _a.redirect_uri;
            return __awaiter(_this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            url = "".concat(this.config.baseURL, "/auth/logout?returnTo=").concat(encodeURIComponent(redirect_uri));
                            return [4 /*yield*/, this.redirecter.redirect(url)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
    }
    AuthenticationClient.inject = function () { return [AuthenticationClientRedirecter_1.AuthenticationClientRedirecter, AuthenticationClientConfig_1.AuthenticationClientConfig, PKCEChallengeProvider_1.PKCEChallengeProvider]; };
    return AuthenticationClient;
}());
exports.AuthenticationClient = AuthenticationClient;
//# sourceMappingURL=AuthenticationClient.js.map